const STORAGE_KEY = 'raquel-harvest:spend';

function todayKey() {
  return new Date().toISOString().slice(0, 10); // YYYY-MM-DD (UTC)
}

function formatTokens(n) {
  if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
  return String(n);
}

export class SpendTracker {
  constructor(storage = globalThis.localStorage, options = {}) {
    this.storage = storage;
    this.softUSD = options.softUSD ?? 2;
    this.hardUSD = options.hardUSD ?? 5;
  }

  _load() {
    const raw = this.storage.getItem(STORAGE_KEY);
    if (!raw) return { date: todayKey(), tokens: 0, costUSD: 0 };
    let parsed;
    try { parsed = JSON.parse(raw); }
    catch { return { date: todayKey(), tokens: 0, costUSD: 0 }; }
    if (parsed.date !== todayKey()) return { date: todayKey(), tokens: 0, costUSD: 0 };
    return parsed;
  }

  _save(data) {
    this.storage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  add({ tokens, costUSD }) {
    const data = this._load();
    data.tokens += tokens;
    data.costUSD += costUSD;
    this._save(data);
  }

  getTodayTokens() { return this._load().tokens; }
  getTodaySpendUSD() { return this._load().costUSD; }

  getStatus() {
    const c = this.getTodaySpendUSD();
    if (c > this.hardUSD) return 'blocked';
    if (c >= this.softUSD) return 'warning';
    return 'ok';
  }

  canSpend() { return this.getStatus() !== 'blocked'; }

  format() {
    return `Today: $${this.getTodaySpendUSD().toFixed(2)} / ${formatTokens(this.getTodayTokens())} tokens`;
  }
}
